import { useEffect, useState } from "react";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import api, { mediaUrl } from "@/lib/api";

export default function OEMPartners() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "OEM Partners | Labpronics Technologies";
    api.get("/content/oem_partners").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const categories = [...new Set(items.map((o) => o.category).filter(Boolean))];

  return (
    <Layout>
      <PageHero eyebrow="Technology Alliances" title="OEM Partners" subtitle="Authorised partner relationships with leading global and Indian technology manufacturers across networking, surveillance, compute, power, drones and security." image="/generated/datacenter.jpg" />
      <section className="py-20">
        <div className="container-lp">
          <Reveal>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5 mb-16">
              {items.map((o, i) => (
                <a key={o.id} href={o.website || "#"} target="_blank" rel="noreferrer" data-testid={`oem-${i}`} className="group bg-white border border-lp-border rounded-sm p-6 flex flex-col items-center justify-center gap-2 h-36 hover:border-lp-cyan hover:shadow-[0_20px_40px_-24px_rgba(10,43,110,0.35)] transition-all">
                  {o.logo ? (
                    <>
                      <div className="h-12 flex items-center justify-center"><img src={mediaUrl(o.logo)} alt={o.name} loading="lazy" className="max-h-10 max-w-[120px] object-contain grayscale group-hover:grayscale-0 transition-all" onError={(e) => { e.target.style.display = "none"; }} /></div>
                      <span className="font-heading font-600 text-lp-blue text-sm text-center">{o.name}</span>
                    </>
                  ) : (
                    <span className="font-heading font-700 text-lp-blue text-lg text-center leading-tight group-hover:text-lp-cyan transition-colors">{o.name}</span>
                  )}
                  {o.category && <span className="text-[10px] tracking-wide uppercase text-lp-muted">{o.category}</span>}
                </a>
              ))}
            </div>
          </Reveal>
          {categories.length > 0 && (
            <Reveal delay={0.1}>
              <div className="border-t border-lp-border pt-10">
                <p className="eyebrow mb-4 text-center">Partner Categories</p>
                <div className="flex flex-wrap justify-center gap-3">
                  {categories.map((c) => <span key={c} className="bg-lp-grey border border-lp-border rounded-sm px-4 py-2 text-sm font-600 text-lp-ink">{c}</span>)}
                </div>
              </div>
            </Reveal>
          )}
        </div>
      </section>
    </Layout>
  );
}
